var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardActions, CardContent } from "@mui/material";
import "./final-step-view.scss";
export default function FinalStepView(props) {
    return (_jsx("div", __assign({ className: "final-step-view" }, { children: _jsxs(Card, { children: [_jsxs(CardContent, { children: [_jsx("div", __assign({ className: "flex-col flex-align-center", style: { marginBottom: "20px" } }, { children: _jsx("img", { src: "/Content/Images/Logo.png", alt: "youCit" }, void 0) }), void 0), _jsx("p", { children: "Thank you for passing through the guided offline assesment." }, void 0)] }, void 0), _jsx(CardActions, {}, void 0)] }, void 0) }), void 0));
}
